import { render, staticRenderFns } from "./ChangeAssetStatusAction.vue?vue&type=template&id=60fee5bf&scoped=true&"
import script from "./ChangeAssetStatusAction.vue?vue&type=script&lang=ts&"
export * from "./ChangeAssetStatusAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fee5bf",
  null
  
)

export default component.exports